import { makeStyles } from '@material-ui/core';
import { ISpcTheme } from '../../../common/theme/ISpcTheme';

export type SoftLockModalClasses = 'modal' | 'root' | 'buttonContainer' | 'message' | 'softLockContinueBtn';

const softLockModalStyles = makeStyles<ISpcTheme, SoftLockModalClasses>(
  ({ typography, palette }) => ({
    modal: {
      background: palette.common.white,
    },
    root: {
      fontFamily: typography.fontFamily,
    },
    message: {
      textAlign: 'center',
      margin: '30px 0',
    },
    buttonContainer: {
      fontFamily: typography.fontFamily,
      maxWidth: '100%',
      textAlign: 'center',
      marginBottom: 30,
    },
    softLockContinueBtn: {},
  }),
  { name: 'Common_SoftLockModal' },
);

export default softLockModalStyles;
